import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  PickersSlotRequestType,
  PickersSlotResponseType,
  UserSlotRequestType,
  SlotDetailType,
  SlotDetailUpdateParams,
  UserSlotType,
} from "sagas/types/slotDetailModal";
import { RootState } from "store";
import { DropdownState, SlotDetailStateType } from "./types/slotDetailModal";

export const initialState: SlotDetailStateType = {
  loading: false,
  validatingPicker: false,
  slot: {
    id: 0,
    status: {
      tag: "",
      description: "",
    },
    startAt: "",
    finishAt: "",
    region: {
      id: "",
      name: "",
    },
    workZone: {
      id: "",
      name: "",
    },
    taken: 0,
    connected: 0,
    capacity: 0,
  },
  newPicker: null,
  newPickerDirty: false,
  pickersConnected: [],
  pickersEnrolled: [],
  pickerErrorCode: null,
  dropdownState: "closed",
  loadedDetail: false,
};

const SLICE_NAME = "slotDetailModal";

export const slotDetailSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getPickersFetch: (
      state: SlotDetailStateType,
      action: PayloadAction<PickersSlotRequestType>
    ) => {
      state.loading = true;
    },
    getPickersError: (
      state: SlotDetailStateType,
      action: PayloadAction<number>
    ) => {
      state.loading = false;
    },
    getPickersSuccess: (
      state: SlotDetailStateType,
      action: PayloadAction<PickersSlotResponseType>
    ) => {
      const { payload } = action;
      state.loading = false;
      if (payload.connected) state.pickersConnected = payload.users;
      else state.pickersEnrolled = payload.users;
    },
    validatePicker: (
      state: SlotDetailStateType,
      action: PayloadAction<UserSlotRequestType>
    ) => {
      state.validatingPicker = true;
    },
    validatePickerInvalid: (
      state: SlotDetailStateType,
      action: PayloadAction<number>
    ) => {
      state.pickerErrorCode = action.payload;
      state.newPicker = null;
      state.validatingPicker = false;
    },
    validatePickerValid: (
      state: SlotDetailStateType,
      action: PayloadAction<UserSlotType>
    ) => {
      const { payload } = action;
      state.validatingPicker = false;
      state.pickerErrorCode = null;
      state.newPicker = payload;
    },
    deletePickerRequest: (
      state: SlotDetailStateType,
      action: PayloadAction<UserSlotRequestType>
    ) => {},
    deletePickerError: () => {},
    deletePickerSuccess: () => {},
    addNewPickerRequest: (
      state: SlotDetailStateType,
      action: PayloadAction<UserSlotRequestType>
    ) => {},
    addNewPickerError: (
      state: SlotDetailStateType,
      action: PayloadAction<number>
    ) => {
      state.pickerErrorCode = action.payload;
      state.validatingPicker = false;
    },
    addNewPickerSuccess: (state: SlotDetailStateType) => {
      state.newPicker = null;
    },
    getSlotDetailRequest: (
      state: SlotDetailStateType,
      action: PayloadAction<number>
    ) => {
      state.loadedDetail = false;
    },
    getSlotDetailError: (state: SlotDetailStateType) => {
      state.slot = initialState.slot;
    },
    getSlotDetailSuccess: (
      state: SlotDetailStateType,
      action: PayloadAction<SlotDetailType>
    ) => {
      const { payload } = action;
      state.slot = payload;
      state.loadedDetail = true;
    },
    updateSlotDetailRequest: (
      state: SlotDetailStateType,
      action: PayloadAction<SlotDetailUpdateParams>
    ) => {},
    updateSlotDetailError: () => {},
    updateSlotDetailSuccess: () => {},
    deleteSlotRequest: (
      state: SlotDetailStateType,
      action: PayloadAction<number>
    ) => {},
    deleteSlotError: () => {},
    deleteSlotSuccess: () => {},
    resetNewPicker: (state: SlotDetailStateType) => {
      state.newPickerDirty = false;
      state.newPicker = null;
      state.pickerErrorCode = null;
    },
    setDropdownState: (
      state: SlotDetailStateType,
      action: PayloadAction<DropdownState>
    ) => {
      state.dropdownState = action.payload;
    },
    resetPickers: (state: SlotDetailStateType) => {
      state.pickersConnected = [];
      state.pickersEnrolled = [];
    },
    setPickerDirty: (
      state: SlotDetailStateType,
      action: PayloadAction<boolean>
    ) => {
      state.newPickerDirty = action.payload;
    },
  },
});

export const slotDetailSelector = (state: RootState) => state.slotDetail;

export const actions = slotDetailSlice.actions;

export default slotDetailSlice.reducer;
